module.exports = __webpack_public_path__ + "img/JOBSTART.092ffc34.png";